module.exports = __webpack_public_path__ + "media/applicants/img-shopper-shopping-052823f4.png";